<template>
    <div class="t3m-ObjectiveFinder-filterPanel-section"
    :class="
      `t3m-ObjectiveFinder-filterPanel-section--${filterItemProperties.filterItemID || ''}`
    ">
        <header class="flex items-baseline cursor-pointer t3m-ObjectiveFinder-filterPanel-section-header group"
                @click="toggleSectionList">
            <h4 class="text-sm uppercase t3m-ObjectiveFinder-filterPanel-section-title">
                {{ filterItemProperties.filterItemTitle }}
            </h4>

            <div class="flex items-center pl-4 ml-auto space-x-2">
                <span class="t3m-ObjectiveFinder-filterPanel-section-filterIndicator"
                      v-if="checkedFilterOptions.length">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 512 512"
                         fill="currentColor"
                         class="w-3 h-3">
                        <path
                              d="M463.952 0H48.057C5.419 0-16.094 51.731 14.116 81.941L176 243.882V416c0 15.108 7.113 29.335 19.2 40l64 47.066c31.273 21.855 76.8 1.538 76.8-38.4V243.882L497.893 81.941C528.042 51.792 506.675 0 463.952 0zM288 224v240l-64-48V224L48 48h416L288 224z" />
                    </svg>
                </span>

                <span class="t3m-ObjectiveFinder-filterPanel-section-toggle group-hover:text-primary"
                      :class="{ 'rotate-180': filterItemProperties.collapsed }">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 320 512"
                         fill="currentColor"
                         class="w-em h-em">
                        <path
                              d="M168.5 164.2l148 146.8c4.7 4.7 4.7 12.3 0 17l-19.8 19.8c-4.7 4.7-12.3 4.7-17 0L160 229.3 40.3 347.8c-4.7 4.7-12.3 4.7-17 0L3.5 328c-4.7-4.7-4.7-12.3 0-17l148-146.8c4.7-4.7 12.3-4.7 17 0z" />
                    </svg>
                </span>
            </div>
        </header>
        <div class="grid gap-1 pb-8 t3m-ObjectiveFinder-filterPanel-section-list"
             :class="`grid-cols-${filterItemProperties.columns}`"
             v-show="!filterItemProperties.collapsed">
            <filter-option v-for="(filterOption, name) in filterItemProperties.filterOptions"
                           :key="name"
                           :filterOptionProperties="filterOption"
                           :filterType="filterItemProperties.type"
                           :filterItemID="filterItemProperties.filterItemID"
                           :filterItemTitle="filterItemProperties.filterItemTitle"
                           :targetProperty="filterItemProperties.targetProperty"
                           :logicalOperator="filterItemProperties.logicalOperator"
                           :pid="filterItemProperties.id"
                           :amountCheckedSiblings="checkedFilterOptions.length"
                           @change="logCheckedFilterOptions" />
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import FilterOption from "@/components/FilterOption.vue";

export default {
    name: "FilterItem",
    data() {
        return {
            // filterOptions: []
        };
    },
    props: {
        filterItemProperties: {
            type: Object,
            default: () => { },
        },
    },
    components: {
        FilterOption,
    },
    computed: {
        filterItemSettings() {
            return {
                id: `uid-${this.filterItemProperties.id}`,
                type: this.filterItemProperties.type,
                targetProperty: this.filterItemProperties.targetProperty,
                logicalOperator: this.filterItemProperties.logicalOperator,
                values: this.getOptionValueOfChecked(),
            };
        },
        checkedFilterOptions() {
            let checkedFilterOptions = this.filterItemProperties.filterOptions.filter(
                (obj) => obj.checked
            );
            return checkedFilterOptions;
        },
    },
    methods: {
        ...mapActions(["addAppliedFilter", "removeAppliedFilter"]),
        logCheckedFilterOptions() {
            this.checkedFilterOptions.length
                ? this.addAppliedFilter(this.filterItemSettings)
                : this.removeAppliedFilter(this.filterItemSettings);
        },
        getOptionValueOfChecked() {
            if (!this.checkedFilterOptions.length) return null;
            let values = [];
            this.checkedFilterOptions.forEach((element) => {
                if (element.filterValues) {
                    values = values.concat(Object.values(element.filterValues));
                }
            });
            return values;
        },
        toggleSectionList() {
            this.filterItemProperties.collapsed = !this.filterItemProperties
                .collapsed;
            this.$emit("toggleCollapse");
        },
    },
};
</script>
